import React from 'react';
import { AppBar, Toolbar, IconButton, Typography, Box } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import CheckIcon from '@mui/icons-material/Check';
import { Dialog, Button, AuthButton } from '../../../../../../Components/MUIs';
import Commons from '../../../../../../Services/Common/Common';
import { BusinessGridCommon } from '../../../../../../Components/BusinessGridCommon';

/**
 * 표준모델 요인 추가 모달 (RIS_BASIC_01/modals/StandardModelModal 과 동일 동작)
 * RIS_BASIC_CUSTOM RiskAssessment 전용 — 로컬 modals 폴더 사용
 */
const StandardModelModal = ({
  open,
  onClose,
  onConfirm,
  rowData = [],
  columnDefs = [],
  gridRef,
  targetGridRef,
  searchRef,
  resetAddButtonError,
  showSnackbar,
  dispatch,
  setSelectedRowData,
  selectedRowData,
  setHazardSituation,
}) => {
  const [selectedRows, setSelectedRows] = React.useState([]);
  const selectedRowNosRef = React.useRef(new Set());

  const handleClose = () => {
    if (resetAddButtonError) {
      dispatch(resetAddButtonError());
    }
    if (searchRef?.current) {
      searchRef.current.modalSearchText = '';
    }
    setSelectedRows([]);
    selectedRowNosRef.current = new Set();
    onClose();
  };

  const handleConfirm = () => {
    if (!selectedRowData || selectedRowData.length === 0) {
      dispatch(
        showSnackbar({
          message: '항목을 선택하세요.',
          type: 'warning',
        })
      );
      return;
    }

    if (onConfirm) {
      onConfirm(selectedRowData);
    }

    if (searchRef?.current) {
      searchRef.current.modalSearchText = '';
    }
    setSelectedRowData([]);
    selectedRowNosRef.current = new Set();
    onClose();
  };

  const handleSearch = (searchText) => {
    if (searchRef?.current) {
      searchRef.current.modalSearchText = searchText;
    }
    if (gridRef?.current) {
      gridRef.current.api.setQuickFilter(searchText);
    }
  };

  return (
    <div
      role="presentation"
      className="MuiDialog-root MuiModal-root"
      inert="true"
    >
      <Dialog
        PaperProps={{
          sx: {
            width: '100%',
            height: '100%',
            maxWidth: 'none',
            borderRadius: 2,
          },
        }}
        title={
          <AppBar
            sx={{
              color: '#fff',
              backgroundColor: '#2CA900',
              position: 'static',
            }}
          >
            <Toolbar>
              <IconButton
                edge="start"
                color="inherit"
                onClick={handleClose}
                aria-label="close"
                sx={{ marginRight: 2 }}
              >
                <CloseIcon />
              </IconButton>
              <Typography
                sx={{
                  ml: 2,
                  flex: 1,
                  textAlign: 'left',
                }}
                variant="h6"
                component="div"
              >
                <Box
                  sx={{
                    whiteSpace: 'normal',
                    overflow: 'visible',
                    textOverflow: 'clip',
                    wordWrap: 'break-word',
                  }}
                >
                  표준모델 요인 추가
                </Box>
              </Typography>
              <Button
                sx={{
                  mr: 1,
                  color: '#2CA900',
                  borderColor: '#2CA900',
                  backgroundColor: '#fff',
                  '&:hover': {
                    backgroundColor: '#249100',
                    color: '#fff',
                  },
                }}
                name={
                  <>
                    <CheckIcon
                      fontSize={Commons.IsMobile() ? 'small' : 'medium'}
                    />
                    선택
                  </>
                }
                onClick={handleConfirm}
                variant="outlined"
              />
            </Toolbar>
          </AppBar>
        }
        open={open}
        onClose={handleClose}
        content={
          <AuthButton
            menuId="RiskEvaluation"
            searchYn="Y"
            saveYn="N"
            printYn="N"
            searchClick={handleSearch}
            grids={
              <>
                <BusinessGridCommon
                  deleteYn1="N"
                  saveYn1="N"
                  addYn1="N"
                  refreshClick1={() => {}}
                  getRowId={(params) => String(params.data?.no ?? '')}
                  setSelectedRowData={setSelectedRowData}
                  title1="표준모델 요인 정보"
                  gridRef={gridRef}
                  columnDefs={columnDefs}
                  rowData={rowData}
                  onCellClicked={() => {}}
                  rowSelection="multiple"
                />
              </>
            }
          />
        }
        useCloseButton={false}
        onSave={() => {}}
        maxWidth="sm"
      />
    </div>
  );
};

export default StandardModelModal;
